import { sendRequest } from '@alme/ui-web/modules/lib-alme-request/src/lib-alme-request';
import { AlmeUIMessage, AlmeUIResponseArray } from '@alme/ui-web/types/response';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../../settings/alight-custom-settings';
import { EntryOriginTypesV5 } from '@alme/api-ts/Alme/EntryOriginTypes';

export default class GetConversationTranscriptExtResponseHandler {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>) {
        this._store = store;
    }

    getReducer() {
        return (state = {}) => { return state; }
    }

    doesHandle(message: AlmeUIMessage) {
        return message.messageType === this._settings.messageConstants.extensibleRequest &&
            (message.messageSource === this._settings.ResponseActions.getConversationTranscript.actionName);
    }

    process(message: AlmeUIMessage) {
        if (!this.doesHandle(message)) return message;

        let loadedHistory = [];
        let history = message.response as AlmeUIResponseArray;

        for (let i = 0; i < history.length; i++) {
            if (history[i].maskedInput)
                loadedHistory.push({ 'DisplayName': history[i].userDisplayName, 'Text': history[i].maskedInput });
            if (history[i].text)
                loadedHistory.push({ 'DisplayName': history[i].agentDisplayName, 'Text': history[i].text });
        }

        const eventinput = {
            messageType : this._settings.messageConstants.appeventRequest,
            eventName : this._settings.appeventConstants.getConversationTranscriptResponse,
            origin : this._settings.originConstants.internal as EntryOriginTypesV5,
            parameters : {
                Success: true,
                ConversationTranscript: loadedHistory
            }
        };

        sendRequest(eventinput);

        return message;
    }

}


// WEBPACK FOOTER //
// ./modules/get-conversation-transcript/message-handlers/ext-response-handler.ts